export default __webpack_public_path__ + "static/media/infobig-icon.61529855.svg";